// Streak pill (top right on Chat / Today / Us): glass, flame (accent when lit today, grey when not yet) + number.
//   <StreakPill count={9} lit={false} onClick={() => go('U1')} />
import { Icon } from './icons';

export interface StreakPillProps { count: number; lit: boolean; onClick?: () => void }

export function StreakPill({ count, lit, onClick }: StreakPillProps) {
  return (
    <button
      type="button" onClick={onClick}
      aria-label={`${count}-day streak, ${lit ? 'lit today' : 'not lit yet today'}`}
      style={{
        display: 'flex', alignItems: 'center', gap: 6, height: 40, minWidth: 44, padding: '0 14px 0 10px', borderRadius: 20,
        background: 'rgba(15,14,12,0.6)', border: '1px solid rgba(255,255,255,0.16)', color: '#F5F1EA', flex: 'none',
      }}
    >
      <Icon name="flame" size={20} strokeWidth={1.8} color={lit ? 'var(--acc)' : '#8C857B'} fill={lit ? 'var(--acc)' : 'none'} />
      <span style={{ fontSize: 16, fontWeight: 800 }}>{count}</span>
    </button>
  );
}
